import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const spinCampaignDetailRoutes = {
  name: 'spin-campaign-detail',
  path: 'spin-campaign/:id',
  component: () => import('./SpinCampaignDetailPage.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
